import React from "react";
import PropTypes from "prop-types";
import { Button, Box } from "samba-ui";
import moment from "moment";
import {
  Container,
  ButtonContainerWithoutBackButton,
  ButtonContainer,
} from "./styles";
import Ticker from "../Ticker";
import { RECEIVE_FEED, RECEIVE_FEEDS } from "../../../../actions/feed";

import { canViewImpression } from "../FeedSpecifications";

const skipIncludedContent = [
  "geo weights",
  "demographic panel",
  "tivo content viewership",
  "x_ref",
  "tivo x_ref",
  "tivo+acr x_ref",
  'streaming geo panel'
];

const Footer = ({
  step,
  onDismiss,
  feed,
  onChangeFeed,
  onChangeStep,
  loading,
  isSample,
  onSubmit,
  includeAllBrands,
  onChangeSuccessMessage,
}) => {
  if (step === "setCountry") {
    return (
      <Container>
        <Ticker currStep={1} />
        <ButtonContainerWithoutBackButton>
          <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
            Cancel
          </Button>
          <Button
            disabled={!feed.country}
            onClick={() => {
              if (feed.country) onChangeStep("clientAndType");
            }}
            primary
          >
            Next
          </Button>
        </ButtonContainerWithoutBackButton>
      </Container>
    );
  } else if (step === "clientAndType") {
    return (
      <Container>
        <Ticker currStep={2} />
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => onChangeStep("setCountry")}
          >
            Back
          </Button>
          <Box>
            <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
              Cancel
            </Button>
            <Button
              disabled={
                !feed.client_id ||
                feed.feed_id === "error" ||
                (feed.type === "spot exposure" && !feed.pbse_version)
              }
              onClick={() => {
                if (feed.client_id) onChangeStep("clientCredentials");
              }}
              primary
            >
              Next
            </Button>
          </Box>
        </ButtonContainer>
      </Container>
    );
  } else if (step === "clientCredentials") {
    return (
      <Container>
        <Ticker currStep={3} />
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => onChangeStep("clientAndType")}
          >
            Back
          </Button>
          <Box>
            <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                skipIncludedContent.indexOf(feed.type) > -1
                  ? onChangeStep("feedSpecifications")
                  : onChangeStep("includedContent");
              }}
              primary
            >
              Next
            </Button>
          </Box>
        </ButtonContainer>
      </Container>
    );
  } else if (step === "includedContent") {
    return (
      <Container>
        <Ticker currStep={4} />
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => onChangeStep("clientCredentials")}
          >
            Back
          </Button>
          <Box>
            <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
              Cancel
            </Button>
            <Button
              disabled={
                includeAllBrands
                  ? false
                  : !feed.included_brands.length &&
                    !feed.included_parents.length &&
                    !feed.included_advertisers.length &&
                    !feed.included_products.length
              }
              onClick={() => onChangeStep("feedSpecifications")}
              primary
            >
              Next
            </Button>
          </Box>
        </ButtonContainer>
      </Container>
    );
  } else if (step === "feedSpecifications") {
    return (
      <Container>
        <Ticker currStep={5} />
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() =>
              skipIncludedContent.indexOf(feed.type) > -1
                ? onChangeStep("clientCredentials")
                : onChangeStep("includedContent")
            }
          >
            Back
          </Button>
          <Box>
            <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
              Cancel
            </Button>
            <Button
              disabled={
                canViewImpression(feed.type) &&
                !feed.quality_metrics.minimum_impression_count
              }
              onClick={() => onChangeStep("datesAndCriteria")}
              primary
            >
              Next
            </Button>
          </Box>
        </ButtonContainer>
      </Container>
    );
  } else if (step === "datesAndCriteria") {
    return (
      <Container>
        <Ticker currStep={6} />
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() =>
              feed.type === "demographic panel"
                ? onChangeStep("clientCredentials")
                : onChangeStep("feedSpecifications")
            }
          >
            Back
          </Button>
          <Box>
            <Button variant="secondary" onClick={onDismiss} margin={0} mr={2}>
              Cancel
            </Button>
            <Button
              // A sample file MUST have a service_stop
              disabled={
                !feed.service_start ||
                (!!isSample && !feed.service_stop) ||
                loading ||
                (feed.service_stop &&
                  feed.service_start &&
                  moment(feed.service_start).isAfter(
                    moment(feed.service_stop)
                  )) ||
                feed.cadenceError
              }
              onClick={() => {
                if (feed.service_start) {
                  onSubmit().then((action) => {
                    // Only close the modal if it was successful
                    if (action.type === RECEIVE_FEED) {
                      onChangeFeed("name", action.feed.name);
                    } else if (action.type === RECEIVE_FEEDS) {
                      onChangeFeed("name", action.feeds[0].name);
                    }
                    if (action.successMessage) {
                      onChangeStep("successMessage");
                      onChangeSuccessMessage(action.successMessage);
                    }
                  });
                }
              }}
              primary
            >
              {loading ? "Processing..." : "Create feed"}
            </Button>
          </Box>
        </ButtonContainer>
      </Container>
    );
  } else if (step === "successMessage") {
    return (
      <Container>
        <ButtonContainerWithoutBackButton>
          <Button onClick={onDismiss} primary>
            Done
          </Button>
        </ButtonContainerWithoutBackButton>
      </Container>
    );
  } else {
    return null;
  }
};

Footer.propTypes = {
  step: PropTypes.string,
  onDismiss: PropTypes.func,
  onChangeSuccessMessage: PropTypes.func,
  selectedClient: PropTypes.shape({
    name: PropTypes.string,
  }),
  feed: PropTypes.shape({
    name: PropTypes.string,
  }),
  includeAllBrands: PropTypes.bool,
};

export default Footer;
